import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import IconButton from '@material-ui/core/IconButton';
import { DraftsOutlined } from '@material-ui/icons';
import {
  Grid, Link, Button, AppBar, Toolbar, Typography, Container, TextField, InputAdornment,
} from '@material-ui/core';

import CustomMessages from './CustomMessages';

import { forgotPassword } from '../../actions';
import useStyles from '../../hooks/useStyles';
import styles from '../../assets/jss/NewLoginScreenStyles';
import headerLogo from '../../assets/images/logo-revbits.png';
import darkLogo from '../../assets/images/theme-switch-dark.svg';
import lightLogo from '../../assets/images/theme-switch-light.svg';

import dmLogo from '../../assets/images/up-login-dm-logo.png';
import lmLogo from '../../assets/images/update_portal_login.png';

function NewForgetPassword(props) {
  document.title = 'Software Update Portal - Forget Password';

  const {
    logo,
    changeTheme,
    history,
  } = props;

  const classes = useStyles(styles)();
  const { t } = useTranslation('translation');

  const [emailId, setEmailId] = useState('');
  const [validEmail, setValidEmail] = useState(false);
  const [isError, setIsError] = useState(false);

  function sendMail(e) {
    e.preventDefault();
    forgotPassword({ email: emailId }).then((res) => {
      const data = res;
      if (data && data.data && data.data.status === 200) {
        history.state = {
          status: 'success',
          msg: data.data.message,
          show: true,
        };
        setEmailId('');
        setIsError(!isError);
      } else if (res && res.response) {
        history.state = {
          status: 'error',
          msg: data.response.errors,
          show: true,
        };
        setEmailId('');
        setIsError(!isError);
      }
    });
  }

  const updateEmailId = (event) => {
    setEmailId(event.target.value);
    if (emailId && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(event.target.value)) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  };

  return (
    <div className={classes.main}>

      <AppBar position="static" className={classes.header}>
        <Toolbar>
          <img className={classes.headerLogo} src={headerLogo} alt="header logo" />
          <Typography variant="h6" className={classes.title} />
          <Button color="inherit" onClick={changeTheme}>
            {logo ? (
              <img src={darkLogo} alt="login logo" />
            ) : (
              <img src={lightLogo} alt="login logo" />
            )}

          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" className={classes.mainLogin}>

        <Grid container spacing={0} style={{ height: '100%' }}>

          <Grid item xs={12} sm={12} md={6} lg={6} className={classes.loginLeft}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <div className="rightLogo">

                  {logo ? (
                    <img src={dmLogo} alt="login logo" />
                  ) : (
                    <img src={lmLogo} alt="" />
                  )}

                  <div style={{ alignSelf: 'center' }}>
                    <p>
                      Rev
                      <span>Bits</span>
                    </p>
                    <span>SOFTWARE UPDATE PORTAL</span>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} />

            </Grid>

          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} style={{ display: 'flex' }}>

            <div className={classes.loginRight}>

              <Grid container spacing={0} alignItems="flex-end" className={classes.mobileLogo}>
                <Grid item xs={12}>
                  {logo ? (
                    <img src={dmLogo} alt="login logo" width="auto" height="120" />
                  ) : (
                    <img src={lmLogo} alt="" width="auto" height="120" />
                  )}
                </Grid>
                <Grid item xs={12}>

                  <h1 className={classes.mobileHeading}>Reset Password</h1>
                </Grid>
              </Grid>

              <form
                className="loginForm"
                name="loginForm"
                onSubmit={(event) => sendMail(event)}
                noValidate
                autoComplete="off"
              >

                <CustomMessages {...props} />

                <Grid container alignItems="flex-end" className={classes.marginBottom}>

                  <Grid spacing={0} alignItems="flex-end" className={classes.fullWidth}>
                    <p className={classes.forgotPasswordLabel}>
                      {t('LOST_PASSWORD')}
                    </p>
                  </Grid>

                  <Grid item className={classes.formInput}>
                    <TextField
                      id="standard-name"
                      label="Your Email"
                      className={`${classes.formInput} ${classes.loginCredentials}`}
                      value={emailId}
                      type="email"
                      autoComplete="on"
                      required
                      onChange={updateEmailId}
                      variant="filled"
                      InputProps={{
                        endAdornment:
  <InputAdornment position="end">
    <IconButton className={classes.fieldIcon} aria-label="toggle password visibility">
      <DraftsOutlined />
    </IconButton>
  </InputAdornment>,
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  justify="flex-end"
                  className={`${classes.linkCss} ${classes.registerUser} ${classes.loginUser}`}
                >

                  <Button
                    type="submit"
                    disabled={validEmail || !emailId}
                    className={classes.activeButton}
                    onClick={sendMail}
                  >
                    {t('Submit')}
                  </Button>

                </Grid>

                <Grid
                  container
                  justify="flex-end"
                  className={`${classes.linkCss} ${classes.forgotPassword}`}
                >
                  <Link component={RouterLink} to="/login">
                    <Trans>LOGIN.BTN</Trans>
                  </Link>
                </Grid>

                <Grid item xs={12}>
                  <img src={headerLogo} className={classes.footerLogo} alt="header logo" />

                </Grid>

              </form>
            </div>
          </Grid>

        </Grid>

      </Container>

      <AppBar className={classes.footer} position="fixed" color="primary">
        <Toolbar>
          <Typography variant="subtitle2" className={classes.title} style={{ textAlign: 'center' }}>
            ©
            {' '}
            {new Date().getFullYear()}
            {' '}
            RevBits Software Update Portal.
            {' '}
            <span>All Rights Reserved.</span>
          </Typography>
        </Toolbar>
      </AppBar>

    </div>
  );
}

NewForgetPassword.propTypes = {};

export default NewForgetPassword;
